var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex-grow mx-4 my-3"},[_c('div',{staticClass:"flex items-center mb-3 mx-4"},[_c('h2',[_vm._v("Siden findes ikke")])]),_c('div',{staticClass:"rounded-sm bg-white shadow p-4"},[_vm._v(" Hovsa! Du er landet på en side, som ikke findes! ")])])
}]

export { render, staticRenderFns }